import { render, staticRenderFns } from "./bszheng.vue?vue&type=template&id=49281dd0&scoped=true&"
import script from "./bszheng.vue?vue&type=script&lang=js&"
export * from "./bszheng.vue?vue&type=script&lang=js&"
import style0 from "./bszheng.vue?vue&type=style&index=0&id=49281dd0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49281dd0",
  null
  
)

export default component.exports